import * as React from 'react';
import { SVGProps } from 'react';

const IconRestartSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="m1.5 1 1.18 1.376A5 5 0 0 1 11.024 5H10v.004a4.002 4.002 0 0 0-6.668-1.867L4.5 4.5H1L1.5 1zm.417 7.886A5 5 0 0 1 1.102 7h1.025a4.002 4.002 0 0 0 6.667 1.863L7.626 7.5h3.5l-.5 3.5-1.18-1.376a4.998 4.998 0 0 1-7.529-.738z" />
  </svg>
);
export default IconRestartSizeXs;
